import * as React from 'react'
import dynamic from 'next/dynamic'

import {Hero, Services, Why, Benefits} from '@components/data-labeling'
import SiteHeader from '@components/SiteHeader'

import SiteFooterWithForm from '@components/SiteFooterWithForm'

const Meta = dynamic(() => import('@components/Meta'))

export default function DataLabel() {
  const EASING = [0.6, 0.01, -0.05, 0.95]

  const animationProps = (delay = 0) => {
    return {
      initial: {opacity: 0, y: 30},
      animate: {opacity: 1, y: 0},
      transition: {duration: 1, ease: EASING, delay},
    }
  }
  const scrollTo = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    const id = e.currentTarget.hash
    window.history.pushState(null, null, id)
    document.querySelector(id)?.scrollIntoView({behavior: 'smooth'})
  }

  return (
    <React.Fragment>
      <Meta
        title='Data Labeling | Data Wow'
        description='Data Wow ให้บริการด้านวิศวกรรมข้อมูล ช่วยเพิมขีดจำกัดให้ธุรกิจคุณ ทั้งบริการ Big Data, AI Development, Web Software Development และ Data Management'
      />
      <Hero animationProps={animationProps} scrollTo={scrollTo} />
      <Services animationProps={animationProps} scrollTo={scrollTo} />
      <Why animationProps={animationProps} scrollTo={scrollTo} />
      <Benefits />
    </React.Fragment>
  )
}

DataLabel.getLayout = function getLayout(page) {
  return (
    <div>
      <SiteHeader className='Nav--data-labeling' />
      {page}
      <SiteFooterWithForm />
    </div>
  )
}
